import { motion } from 'framer-motion'
import { Certificate } from '@phosphor-icons/react'

export function About() {
  return (
    <div className="max-w-4xl mx-auto">
      <motion.div
        className="relative overflow-hidden rounded-2xl p-8 bg-gradient-to-br from-orange-500/20 via-red-500/20 to-rose-500/20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex items-center gap-4 mb-8">
          <Certificate size={36} className="text-orange-400" />
          <h2 className="text-2xl font-bold">About</h2>
        </div>

        <div className="space-y-6 text-lg">
          <p>
            Trinity is a decentralized bond platform built on PulseChain, offering a new way to earn rewards through bond investments.
          </p>

          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-orange-300">How it Works</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Purchase bonds using supported assets (FED, TBILL, PDAI)</li>
              <li>Earn guaranteed returns over fixed terms</li>
              <li>Trade your bonds on the secondary market</li>
              <li>Redeem bonds at maturity for full value plus returns</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-orange-300">Features</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Multiple term options with different return rates</li>
              <li>Secondary market trading</li>
              <li>Early redemption options</li>
              <li>Transparent fee structure</li>
              <li>Secure smart contract infrastructure</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-orange-300">Fees</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>5% redemption fee on matured bonds</li>
              <li>3% early reclaim fee</li>
              <li>1% service fee on bond creation</li>
              <li>1 TRNTY token required for bond creation</li>
            </ul>
          </div>

          <div className="mt-8 p-4 bg-orange-500/10 rounded-lg">
            <p className="text-center text-orange-300">
              Start your journey with Bank of Sain†s today by purchasing your first bond.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  )
} 